import { render, staticRenderFns } from "./list-users.vue?vue&type=template&id=fbc8008e&scoped=true&"
import script from "./list-users.vue?vue&type=script&lang=js&"
export * from "./list-users.vue?vue&type=script&lang=js&"
import style0 from "./list-users.vue?vue&type=style&index=0&id=fbc8008e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc8008e",
  null
  
)

export default component.exports